'use strict';

/* global angular */

angular.module('atex.aceui.application').factory('ContentEditor',
  ['$q', '$rootScope', 'ContentService', 'TemplateService', 'AuthenticationService',
    function ($q, $rootScope, ContentService, TemplateService, AuthenticationService) {

      const Utils = atex.aceui.ObjectUtils;
      const AceError = atex.aceui.error.Error;

      const fetchUserdata = () => {
        return AuthenticationService.getCurrentUser()
          .then((currentUser) => {
            return ContentService.getContent({ alias: `_userdata/${currentUser.userId}` })
              .catch((error) => {
                // We default to empty user data response
                if (typeof error.type !== 'undefined' && error.type === atex.aceui.error.types.NOT_FOUND) {
                  return { content: { aspects: {} } };
                }

                return $q.reject(AceError ({
                  origin: 'Content Editor',
                  type: atex.aceui.error.types.UNKNOWN,
                  severity: atex.aceui.error.severities.CRITICAL,
                  cause: 'Error reading user data for hook script!',
                  rootCause: error
                }));
              });
          })
          .then((userDataResponse) => {
            return userDataResponse.content;
          });
      };

      const fetchHooks = (hook, type) => {
        return ContentService.getContent ({ alias: '_config/aceCallbacksConfig', view: 'aceLatest' })
          .then ((response) => {
            const hooksAliases = Utils.getByPath (response, `content/aspects/aceCallbacksConfig/${hook}Hooks/${type}`) || [];

            return Promise.all (hooksAliases.map (alias => {
              return ContentService.getContent ({ alias: `_config/${alias}`, view: 'aceLatest' })
                .then (response => Utils.getByPath (response, 'content/aspects/aceCallback/config/script'))
                .catch (error => {
                  return Promise.reject (AceError ({
                    origin: 'Content Editor Service',
                    type: atex.aceui.error.types.CONFIG_ERROR,
                    severity: atex.aceui.error.severities.CRITICAL,
                    cause: `Error fetching content hook script ${alias} configured in aceCallbacksConfig for the type ${type}`,
                    rootCause: error
                  }));
                });
            }))
              .then (scripts => scripts.map (script => {
                const scriptFn = new Function ('window', 'atex', 'ContentService', `${script}; return ${hook};`);
                return scriptFn (window, atex, ContentService);
              }))
              .catch (error => {
                if (!error.origin === 'Content Editor Service') {
                  return Promise.reject (AceError ({
                    origin: 'Content Editor Service',
                    type: atex.aceui.error.types.RUNTIME,
                    severity: atex.aceui.error.severities.CRITICAL,
                    cause: `Script Evaluation Error ${hook} - [${hooksAliases.join()}]`,
                    rootCause: error
                  }));
                }

                return Promise.reject (error);
              });
          });
      };

      const executeHooks = (hooks, content, context) => {
        return fetchUserdata ()
          .then ((userData) => {
            return hooks.reduce ((accPromise, callback) => {
              return accPromise.then (content => {
                return callback.call ({}, content, context, userData);
              })
                .catch (error => {
                  return Promise.reject (AceError ({
                    origin: 'Content Editor Service',
                    type: atex.aceui.error.types.RUNTIME,
                    severity: atex.aceui.error.severities.CRITICAL,
                    cause: `Error executing script: [ ${callback} ]`,
                    rootCause: error
                  }));
                });
            }, Promise.resolve (content) )
              .catch (error => {
                if (!error.origin) {
                  return $q.reject (AceError ({
                    origin: 'Content Editor Service',
                    type: atex.aceui.error.types.RUNTIME,
                    severity: atex.aceui.error.severities.CRITICAL,
                    cause: 'Error executing hook scripts',
                    rootCause: error
                  }));
                }

                return Promise.reject(error);
              });
          });
      };

      return {
        openContent: function () {},

        onContentClone: (content) => {
          // We are breaking a window here.
          // Perhaps the (complete) context should be passed in as a parameter instead?

          const context = $rootScope.contentObjectInEdit ?
            { contentInEdit: $rootScope.contentObjectInEdit }
            : {};

          return fetchHooks ('onContentClone', content.system.contentType)
            .then (hooks => {
              return executeHooks (hooks, content, context);
            });
        },

        onContentInit: function (content) {
          // We are breaking a window here.
          // Perhaps the (complete) context should be passed in as a parameter instead?

          const context = $rootScope.contentObjectInEdit ?
            { contentInEdit: $rootScope.contentObjectInEdit }
            : {};

          return fetchHooks ('onContentInit', content.system.contentType)
            .then (hooks => {
              return executeHooks (hooks, content, context);
            });
        },

        isOpenable: function (object) {
          return TemplateService.getTemplates('Read', object.type)
            .then (function (templateList) {
              return templateList && templateList.length > 0;
            });
        }
      };
    }]);
